'use strict';

var blue$1 = require('../../../../_virtual/blue.js_commonjs-exports.js');

Object.defineProperty(blue$1.__exports, "__esModule", {
  value: true
});
blue$1.__exports.default = void 0;
var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
var _default = blue;
blue$1.__exports.default = _default;
